module.exports = __webpack_public_path__ + "static/delivery-service-b88282962689eee6777837cb9b61f5bc.png";